import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/AlertDialog/AlertDialog";
import { useMyExplorations } from "../../hooks/myExplorations/useMyExplorations";
import type { Dispatch, SetStateAction } from "react";

const DeleteExplorationDialog = ({
  open,
  onOpenChange,
  exploration,
  setExplorations,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  exploration: any;
  setExplorations: Dispatch<
    SetStateAction<{
      explorations: any[];
      classes: any[];
      rotations: any[];
      sessions: any[];
      teachers: any[];
    }>
  >;
}) => {
  const { deleteExploration, loading } = useMyExplorations();

  const onDelete = async () => {
    const deleted = await deleteExploration(exploration._id);
    if (!deleted) return;

    setExplorations((prev) => ({
      ...prev,
      explorations: prev.explorations.filter(
        (e) => e._id !== deleted.explorationId,
      ),
      classes: prev.classes.filter((c) => !deleted.classes.includes(c._id)),
    }));
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete {exploration.name}</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you would like to delete {exploration.name}?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={loading.delete}>
            {loading.delete ? "Loading..." : "Cancel"}
          </AlertDialogCancel>
          <AlertDialogAction
            variant="destructive"
            onClick={onDelete}
            disabled={loading.delete}
          >
            {loading.delete ? "Loading..." : "Delete Exploration"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export { DeleteExplorationDialog };
